import React from 'react';
import { Star } from 'react-feather';
import { useIntl } from 'react-intl';

import { useConfig } from '../ConfigContext';
import { useMyTeam } from './MyTeamContext';

const TeamStar = ({ team }) => {
  const { seasonId } = useConfig();
  const [ teamId, setTeam ] = useMyTeam();
  const { formatMessage } = useIntl();

  if (!team || team.seasonId !== seasonId) return null;

  const toggle = () => {
    if (teamId !== team.id) {
      setTeam(team.id)
    } else {
      setTeam(null)
    }
  }

  const fill = team.id === teamId ? "var(--yellow)" : "transparent";
  return <span onClick={toggle} title={formatMessage({ id: 'components.myteam.pin' })}>
    <Star size="1.25rem" fill={fill} />
  </span>
}

export default TeamStar;
